import React from 'react'
import PropTypes from 'prop-types'

export default function CrosshairIcon(props) {
  return (
    <svg width={props.width} height={props.height} viewBox='0 0 27 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_4981_198645)'>
        <circle cx='12.9999' cy='12.9999' r='1.03704' fill={props.color} />
      </g>
      <path d='M14 1H15V11H13V10H14V1Z' fill='black' fillOpacity='0.5' />
      <path d='M14 17H15V27H13V26H14V17Z' fill='black' fillOpacity='0.5' />
      <rect x='12' width='2' height='10' fill={props.color} />
      <path d='M1 15L1 14L10 14L10 13L11 13L11 15L1 15Z' fill='black' fillOpacity='0.5' />
      <path d='M17 15L17 14L26 14L26 13L27 13L27 15L17 15Z' fill='black' fillOpacity='0.5' />
      <rect y='14' width='2' height='10' transform='rotate(-90 0 14)' fill={props.color} />
      <rect x='16' y='14' width='2' height='10' transform='rotate(-90 16 14)' fill={props.color} />
      <rect x='12' y='16' width='2' height='10' fill={props.color} />
      <defs>
        <filter id='filter0_d_4981_198645' x='7.96289' y='11.9629' width='10.074' height='10.074' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4981_198645' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4981_198645' result='shape' />
        </filter>
      </defs>
    </svg>
  )
}

CrosshairIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
}

CrosshairIcon.defaultProps = {
  color: '#fafafa',
  height: 27,
  width: 27
}
